import {SUCCESS_STATUS} from "@/contants/base";

export const setList = (state, payload) => state.list = payload;
export const setEmployeeList = (state, payload) => state.employeeList = payload;
export const setProposal = (state, payload) => state.proposal = payload;
export const setListInMonth = (state, payload) => state.listInMonth = payload;
export const setComments = (state, payload) => state.comments = payload;
export const setProposalId = (state, payload) => state.proposalId = payload;
export const setProposalFrom = (state, payload) => state.proposalFrom = payload;
export const setCurrentStatus = (state, payload) => state.currentStatus = payload;
export const setCurrentPriority = (state, payload) => state.currentPriority = payload;
export const setCurrentTags = (state, payload) => state.currentTags = payload;
export const setThisMonthProposalTotal = (state, payload) => state.thisMonthProposalTotal = payload;
export const setTaskStatus = (state, {stepIndex, taskIndex, status}) => {
  state.proposal.steps[stepIndex].tasks[taskIndex].status = status;
}
export const setStepStatus = (state, {stepIndex, status}) => {
  state.proposal.steps[stepIndex].status = status;
};
export const updateAllStepStatus = (state, {status}) => {
  if (status == SUCCESS_STATUS) {
    state.proposal.steps.map((step, stepIndex) => {
      step.status = status;
      state.proposal.steps[stepIndex].tasks.map((task, index) => {
        task.status = status;
      })
    })
  }
};
export const updateAllTaskStatus = (state, {stepIndex, status}) => {
  state.proposal.steps[stepIndex].tasks.map((task, index) => {
    task.status = status;
  })
};
export const setProposalStatus = (state, {status}) => {
  state.proposal.status = status
}
export const setProposalProgress = (state, {progress}) => {
  state.proposal.progress = progress
}
export const setProposalsDeadlineInMonth = (state, payload) => state.proposalsDeadlineInMonth = payload;

export const deleteProposal = (state, encryptId) => {
  state.list = state.list.filter(proposal => proposal.id_encrypt !== encryptId)
  state.proposalsDeadlineInMonth = state.proposalsDeadlineInMonth.filter(proposal => proposal.id_encrypt !== encryptId)
}

export const setTodoDashboard = (state, payload) => state.todoDashboard = payload;

export const setTodoChartDashboard = (state, payload) => state.todoChartDashboard = payload;

export const setInitTodoDashboard = (state, payload) => state.initTodoDashboard = payload;

export const setIsMyTodo = (state, payload) => state.isMyTodo = payload;